import { Cookies } from 'react-cookie';

/**
 * Sets the session
 * @param {*} user
 */
const setSession = user => {
  let cookies = new Cookies();
  if (user) cookies.set('chungungo', JSON.stringify(user), { path: '/' });
  else cookies.remove('chungungo', { path: '/' });
};

const setOneTimeEvents = data => {
  let cookies = new Cookies();
  const prevData = cookies.get('chungungo_one_time');
  cookies.set(
    'chungungo_one_time',
    JSON.stringify({
    ...prevData,
    ...data,
    }),
    { path: '/' }
  );
}

const getOneTimeEvents = () => {
  const cookies = new Cookies();
  const data = cookies.get('chungungo_one_time');
  return data ? (typeof data == 'object' ? data : JSON.parse(data)) : {};
}

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
  const cookies = new Cookies();
  const user = cookies.get('chungungo');
  return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

const updateUser = user => {
  let cookies = new Cookies();
  const previousUser = getLoggedInUser();

  if (previousUser) {
    cookies.remove('chungungo', { path: '/' });
    cookies.set(
      'chungungo',
      JSON.stringify({
        token: user.token || previousUser.token,
        user : user.user || previousUser.user,
      }),
      { path: '/' }
    );
  } else {
    console.log('No user to update');
  }
};

const isAllowedToPlayVideo = () => {
  console.debug(getLoggedInUser())
  try{
  console.debug((getLoggedInUser() || {user: {roles: []}}).user.roles.find(role => ['admin', 'guest', 'editor', 'corporate', 'subscriber'].includes(role)))
  }catch(error){

  }
  return (getLoggedInUser() || {user: {roles: []}}).user.roles.find(role => ['admin', 'guest', 'editor', 'corporate', 'subscriber'].includes(role));
};

export {
  getLoggedInUser,
  setSession,
  isAllowedToPlayVideo,
  updateUser,
  setOneTimeEvents,
  getOneTimeEvents,
};